import Vue from "vue";
import { groupBy } from "../utils.js";

const actorsPropertiesStore = {
	plugins: [],
	state: {},
	mutations: {
		updateActorsPropertiesFor(state, payload) {
			// pp.log("VUEX: Updaing actorsPropertiesStore with", payload);
			const incomingApsByActorId = groupBy(payload, (ap) => ap.actor_id);
			// pp.log("- by actor", incomingApsByActorId);
			Object.entries(incomingApsByActorId).forEach(([actorId, newAps]) => {
				// pp.log("-- actor", actorId, newAps);
				if (state[actorId]) {
					const calculatedApps = state[actorId].map((oldAp) => {
						const newAp = newAps.find((newAp) => newAp.id == oldAp.id);
						if (newAp === undefined) {
							return oldAp;
						}

						if (oldAp.omit_transition) {
							// pp.log("found omit_transition to preserve", oldAp.omit_transition);
							Vue.set(newAp, "omit_transition", oldAp.omit_transition);
						} else if (oldAp.preview_values) {
							// Never preserve the preview values if omit_transition is present (this has the same effet as calling clearPreviewFor, but this way it happens at the same time)
							const oldPhaseValuePair =
								oldAp.values[pp.gameState.phaseId] ||
								Object.values(oldAp.values).slice(-1);
							Vue.set(
								newAp,
								"old_current_value",
								oldPhaseValuePair.current_value,
							);
							Vue.set(newAp, "preview_values", oldAp.preview_values);
						}
						return newAp;
					});
					Vue.set(state, actorId, calculatedApps);
				} else {
					// pp.log("Setting state for first time", actorId, newAps);
					Vue.set(state, actorId, newAps);
				}
			});
			// const vals = state[actorId].map(function(ap) {
			// 	return `${ap.property.type_key} : ${ap.current_value} - ${ap.property.id}`
			// }).join('\n');
			// console.log(`************** Updated State for Actor #${actorId} **************`);
			// console.log(vals);
		},

		markTransitionOmissionOfProperties(state, { actorId, setTimeout }) {
			if (!state[actorId]) {
				return;
			}

			// pp.log("toggling omit_transition, current:", state[actorId][0].omit_transition, recur, state[actorId][0].property.type_key);
			state[actorId] = state[actorId].map((ap) => {
				Vue.set(ap, "omit_transition", !ap.omit_transition);
				return ap;
			});

			if (!setTimeout) {
				return;
			}
			window.setTimeout(() => {
				VueStore.commit("markTransitionOmissionOfProperties", {
					actorId: actorId,
					setTimeout: false,
				});
			}, 2500);
		},

		clearPreviewFor(state, actorId) {
			if (!state[actorId]) {
				return;
			}

			state[actorId] = state[actorId].map((ap) => {
				Vue.set(ap, "preview_values", undefined);
				Vue.set(ap, "old_current_value", undefined);
				return ap;
			});
		},

		previewModifiersFor(state, { actorId, modifiers }) {
			if (state[actorId] === undefined) {
				return;
			}

			state[actorId].map((ap) => {
				const modifier = modifiers.find(
					(mod) => mod.property.id === ap.property_id,
				);
				if (modifier) {
					const lower = modifier.static_modifying_range[0];
					const upper = modifier.static_modifying_range[1];
					let range = [lower, upper];
					if (modifier.calculates_percentage) {
						const lowerAsFloat = lower / 100;
						const upperAsFloat = upper / 100;
						range = [
							lowerAsFloat * ap.current_value - ap.current_value,
							upperAsFloat * ap.current_value - ap.current_value,
						];
					}
					Vue.set(ap, "preview_values", {
						range: range,
						single_value: range[0] === range[1] ? range[0] : null,
						modifier: modifier,
					});
				} else {
					Vue.set(ap, "preview_values", null);
				}
				return ap;
			});
		},
	},

	getters: {
		actorsProperties: (state, getters) => () => {
			return state;
		},
		actorsPropertiesFor: (state, getters) => (actorId) => {
			return state[actorId];
		},
		actorsPropertiesOfType: (state, getters) => (propType) => {
			return Object.values(state)
				.flat()
				.filter((ap) => {
					return propType == ap.property.type_key;
				});
		},
		actorPropertyOfTypeFor: (state, getters) => (actorId, propType) => {
			const actorsProperties = getters.actorsPropertiesFor(actorId);
			if (actorsProperties !== undefined) {
				return actorsProperties.find((ap) => ap.property.type_key == propType);
			}
		},
		actorsPropertiesOfTypeFor: (state, getters) => (actorIds, propTypeKeys) => {
			if (typeof actorIds === "number") {
				actorIds = [actorIds];
			}
			let propsToReturn = [];
			actorIds.forEach((actorId, index) => {
				const propsOfActor = getters.actorsPropertiesFor(actorId);
				if (propsOfActor !== undefined) {
					propsToReturn = propsToReturn.concat(
						propsOfActor.filter((ap) =>
							propTypeKeys.includes(ap.property.type_key),
						),
					);
				}
			});
			return propsToReturn;
		},
		actorsPropertiesWithoutTypeFor:
			(state, getters) => (actorId, propTypeKey) => {
				const actorsProperties = getters.actorsPropertiesFor(actorId);
				if (actorsProperties !== undefined) {
					return actorsProperties.filter(
						(ap) => ap.property.type_key != propTypeKey,
					);
				}
			},
	},

	actions: {},
};

export default actorsPropertiesStore;
